<div class="page">
  <div class="section-body mt-3">
    <div class="container-fluid">
      <div class="row clearfix">
        <div class="col-lg-12">
          <div class="mb-4">
            <h4>Welcome Sethu Krish!</h4>
            <small
              >Measure How Fast You’re Growing Monthly Recurring Revenue.
              <a href="#">Learn More</a></small
            >
          </div>
        </div>
      </div>

      <div class="section-body">
        <div class="container-fluid"></div>
      </div>
    </div>

    <div class="row clearfix">
      <div class="col-6 col-md-4 col-xl-4">
        <div class="card">
          <div class="card-body ribbon">
            <a
              href="#"
              class="my_sort_cut text-muted"
              (click)="openUploadModal(template)"
              ><i class="fa fa-upload"></i><span>Upload</span></a
            >
          </div>
        </div>
      </div>
      <div class="col-6 col-md-4 col-xl-4">
        <div class="card">
          <div class="card-body ribbon">
            <a href="#" class="my_sort_cut text-muted" routerLink="/update"
              ><i class="fa fa-wrench"></i><span>Update</span></a
            >
          </div>
        </div>
      </div>
      <div class="col-6 col-md-4 col-xl-4">
        <div class="card">
          <div class="card-body">
            <a
              href="#"
              class="my_sort_cut text-muted"
              routerLink="/reports-home"
              ><i class="fa fa-bar-chart"></i><span>Reports</span></a
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row clearfix row-deck">
      <div class="col-xl-4 col-lg-4">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Project Stats</h3>
          </div>
          <div
            id="collapseBasic"
            class="card-body collapse in show"
            ng-reflect-collapse="false"
            aria-expanded="true"
            aria-hidden="false"
            style="display: block"
          >
            <div class="row text-center">
              <div class="col-sm-4 border-right pb-4 pt-4">
                <label class="mb-0">Total</label>
                <h4
                  class="font-30 font-weight-bold text-col-blue counter"
                  ng-reflect-from="0"
                  ng-reflect--count-to="42"
                  ng-reflect-duration="1"
                >
                  {{ projectProgress.length }}
                </h4>
              </div>
              <div class="col-sm-4 border-right pb-4 pt-4">
                <label class="mb-0">Ongoing</label>
                <h4
                  class="font-30 font-weight-bold text-col-blue counter"
                  ng-reflect-from="0"
                  ng-reflect--count-to="23"
                  ng-reflect-duration="1"
                >
                  {{ projectProgress.length - completeProjects }}
                </h4>
              </div>
              <div class="col-sm-4 pb-4 pt-4">
                <label class="mb-0">Complete</label>
                <h4
                  class="font-30 font-weight-bold text-col-blue counter"
                  ng-reflect-from="0"
                  ng-reflect--count-to="8"
                  ng-reflect-duration="1"
                >
                  {{ completeProjects }}
                </h4>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped table-vcenter mb-0">
                <tbody>
                  <tr *ngIf="projectProgress.length == 0">
                    No Projects uploaded
                  </tr>
                  <tr *ngFor="let project of projectProgress">
                    <td>
                      <div class="clearfix">
                        <div class="float-left">
                          <strong>{{ project.actualProgress }}%</strong>
                        </div>
                        <div class="float-right">
                          <small class="text-muted">{{
                            project.project?.contractTitle
                          }}</small>
                        </div>
                      </div>
                      <div class="progress progress-xs">
                        <div
                          role="progressbar"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          class="progress-bar bg-green"
                          [ngStyle]="{ width: project.actualProgress + '%' }"
                        ></div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-4 col-md-4">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Project Profits</h3>
          </div>
          <div class="card-body">
            <div class="d-flex align-items-baseline">
              <h1 class="mb-0 mr-2">9.8</h1>
              <p class="mb-0">
                <span class="text-success"
                  >1.6% <i class="fa fa-arrow-up"></i
                ></span>
              </p>
            </div>
            <h6 class="text-uppercase font-10">Project Profit In Billions</h6>
            <div class="progress progress-xs">
              <div
                role="progressbar"
                aria-valuenow="15"
                aria-valuemin="0"
                aria-valuemax="100"
                class="progress-bar"
                style="width: 15%"
              ></div>
              <div
                role="progressbar"
                aria-valuenow="20"
                aria-valuemin="0"
                aria-valuemax="100"
                class="progress-bar bg-info"
                style="width: 20%"
              ></div>
              <div
                role="progressbar"
                aria-valuenow="30"
                aria-valuemin="0"
                aria-valuemax="100"
                class="progress-bar bg-success"
                style="width: 30%"
              ></div>
              <div
                role="progressbar"
                aria-valuenow="20"
                aria-valuemin="0"
                aria-valuemax="100"
                class="progress-bar bg-orange"
                style="width: 5%"
              ></div>
              <div
                role="progressbar"
                aria-valuenow="20"
                aria-valuemin="0"
                aria-valuemax="100"
                class="progress-bar bg-indigo"
                style="width: 13%"
              ></div>
            </div>
            <div>
              <table class="table table-striped table-vcenter">
                <tbody>
                  <tr *ngIf="projectProfit.length == 0">
                    No Projects
                  </tr>
                  <tr *ngFor="let proj of projectProfit">
                    <td><i class="fa fa-circle text-blue"></i></td>
                    <td class="tx-medium">{{ proj.project?.contractTitle }}</td>
                    <td class="text-right">{{ proj.actualProfit }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-4">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Overall Issues</h3>
          </div>
          <!-- <div class="card-body">
            <div class="d-flex align-items-baseline">
              <h2 class="font-28 mr-2">4.2</h2>
              <div class="font-14">
                <i class="fa fa-star text-orange"></i
                ><i class="fa fa-star text-orange"></i
                ><i class="fa fa-star text-orange"></i
                ><i class="fa fa-star text-orange"></i
                ><i class="fa fa-star"></i>
              </div>
            </div>
            <p class="mb-0 font-12">Check Issues Priority Wise</p>
          </div> -->
          <div class="table-responsive">
            <table class="table table-striped table-vcenter mb-0">
              <tbody>
                <tr *ngIf="overallIssues && overallIssues.length == 0">
                  <td>No recent issues</td>
                </tr>
                <tr *ngFor="let issue of overallIssues">
                  <td>
                    <div class="font-15">
                      {{ issue.description | ellipsis: 50 }}
                    </div>
                    <span class="text-muted">{{
                      issue.project.contractTitle | ellipsis: 100
                    }}</span>
                  </td>
                  <td>
                    <span
                      class="tag"
                      [ngClass]="{
                        'tag-danger': issue.status == 'Open',
                        'tag-success': issue.status == 'Closed'
                      }"
                      >{{ issue.status == "Open" ? "Open" : "Resolved" }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="section-body">
  <div class="container-fluid"></div>
</div>

<ng-template #template>
  <div role="dialog">
    <div class="modal-header">
      <h4 class="modal-title pull-left">Upload Project</h4>
      <button
        type="button"
        class="close pull-right"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="custom-control custom-switch mb-3 ml-3">
        <input
          type="checkbox"
          class="custom-control-input"
          id="customSwitch1"
          [(ngModel)]="isExistingProject"
        />
        <label class="custom-control-label" for="customSwitch1"
          >Existing Project</label
        >
      </div>
      <div *ngIf="!isExistingProject">
        <app-new-project-upload
          (success)="onSuccessfulUpload($event)"
        ></app-new-project-upload>
      </div>
      <div *ngIf="isExistingProject">
        <app-existing-project-upload
          (success)="onSuccessfulUpload($event)"
        ></app-existing-project-upload>
      </div>
    </div>
  </div>
</ng-template>
